function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.23 3.46a1.23 1.23 0 110-2.46 1.23 1.23 0 010 2.46zm3.34-.66h9.72a.7.7 0 000-1.41H5.58a.7.7 0 000 1.4zM1 7.2a1.23 1.23 0 102.46 0 1.23 1.23 0 00-2.46 0zm4.57.57h9.72c.4 0 .71-.31.71-.7a.7.7 0 00-.7-.7H5.57a.7.7 0 000 1.4zM1 12.2a1.23 1.23 0 102.46 0 1.23 1.23 0 00-2.46 0zm4.57.57h9.72a.7.7 0 000-1.41H5.58a.7.7 0 000 1.4z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.25 2.1c0 .52-.43.95-.96.95H5.57a.96.96 0 010-1.91h9.73c.52 0 .95.43.95.95zm0 4.98c0 .52-.43.95-.96.95H5.57a.96.96 0 010-1.9h9.73c.52 0 .95.42.95.95zm0 4.98c0 .53-.43.96-.96.96H5.57a.96.96 0 010-1.91h9.73c.52 0 .95.43.95.95zM2.23 3.71a1.48 1.48 0 110-2.96 1.48 1.48 0 010 2.96zM16 2.1c0 .4-.31.7-.7.7H5.56a.7.7 0 010-1.4h9.73c.39 0 .7.31.7.7zM2.23 8.7a1.48 1.48 0 110-2.96 1.48 1.48 0 010 2.97zM16 7.09a.7.7 0 01-.7.7H5.56a.7.7 0 010-1.4h9.73c.39 0 .7.3.7.7zm-13.77 6.6a1.48 1.48 0 110-2.96 1.48 1.48 0 010 2.96zM16 12.06c0 .4-.31.7-.7.7H5.56a.7.7 0 010-1.4h9.73c.39 0 .7.31.7.7zM1 2.23a1.23 1.23 0 102.46 0 1.23 1.23 0 00-2.46 0zm1.23 6.22a1.23 1.23 0 110-2.47 1.23 1.23 0 010 2.47zm0 4.98a1.23 1.23 0 110-2.46 1.23 1.23 0 010 2.46z",
  clipRule: "evenodd"
});

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    fill: "#fff",
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.3b00bcc6.svg";
export { ForwardRef as ReactComponent };